<div
  class="ngx-shimmer"
  [ngStyle]="{
    width: width,
    height: shimmerHeight,
    borderRadius: shimmerBorderRadius,
  }"
  [ngClass]="{ rtl: direction === 'rtl' }"
></div>
